var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","tag":"section"}},[_c('h1',[_vm._v(_vm._s(_vm.name))]),_c('v-data-table',{attrs:{"headers":_vm.ergebnis.headers,"items":_vm.ergebnisse,"sort-by":"time","items-per-page":-1},scopedSlots:_vm._u([{key:"item.time",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("float2_0")(item.time))+"s ")]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }